import React from "react";

const HeaderSection: React.FC = () => (
  <div className="mb-8 text-center">
    <div className="max-w-2xl mx-auto">
      <h2 className="text-3xl font-bold text-navy-900 mb-4">Additional Services</h2>
      <p className="text-lg text-gray-600 mb-6">
        Enhance your license with these optional services (multiple selection allowed)
      </p>
      <div className="h-1 w-24 bg-navy-900 mx-auto rounded-full" />
    </div>
  </div>
);

const ServiceGridSkeleton: React.FC = () => (
  <div className="px-4 md:px-6">
    <HeaderSection />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="p-6 border-2 border-gray-200 rounded-xl bg-white">
          <div className="animate-pulse space-y-6">
            <div className="flex items-start gap-4">
              <div className="h-12 w-12 bg-gray-200 rounded-lg" />
              <div className="space-y-2 flex-1">
                <div className="h-6 bg-gray-200 rounded w-3/4" />
                <div className="h-4 bg-gray-200 rounded w-full" />
              </div>
            </div>
            <div className="flex justify-between">
              <div className="h-8 bg-gray-200 rounded w-1/4" />
              <div className="h-6 bg-gray-200 rounded w-1/4" />
            </div>
            <div className="flex items-center gap-3">
              <div className="h-5 w-5 bg-gray-200 rounded-full" />
              <div className="h-4 bg-gray-200 rounded w-1/3" />
              <div className="h-4 bg-gray-200 rounded w-1/3" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ServiceGridSkeleton;
